const css = `.HhTpwa__selected:not(.HhTpwa__disabled){background-color:var(--base-surfaces-activated)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"selected":"HhTpwa__selected","disabled":"HhTpwa__disabled"};
